'use client';

import React from 'react';
import styles from './Faq.module.scss';
import { useTranslation } from '@app/i18n/useTranslationClient';
import Container from '@/components/Container/Container';
import { Accordion, AccordionIcon, BorderColor } from '@/components/accordion/Accordion';
import { IFaqItem } from '@/hooks/api/fetchFaq/useFaq.interfaces';

export interface IFaq {
    items: IFaqItem[];
}

export const Faq: React.FC<IFaq> = ({ items }) => {
    const { t } = useTranslation();

    return (
        <Container classes={styles.faqContainer}>
            <h2 className={styles.faqContainerTitle}>{t('translations.faq.title')}</h2>
            {items.map((item, index) => (
                <Accordion
                    key={index}
                    classes={{
                        wrapper: styles.faqContainerAccordion,
                        title: styles.faqContainerAccordionTitle,
                        titleWrapper: styles.faqContainerAccordionTitleWrapper,
                        content: styles.faqContainerAccordionContent,
                    }}
                    borderColor={BorderColor.WHITE}
                    iconType={AccordionIcon.ARROW_WHITE}
                    title={item.question}>
                    <div
                        className={styles.faqContainerAccordionText}
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                </Accordion>
            ))}
        </Container>
    );
};
